import { render } from "./CallToActionEntries.vue?vue&type=template&id=900ce028&scoped=true"
import script from "./CallToActionEntries.vue?vue&type=script&lang=js"
export * from "./CallToActionEntries.vue?vue&type=script&lang=js"

import "./CallToActionEntries.vue?vue&type=style&index=0&id=900ce028&scoped=true&lang=css"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900ce028"]])

export default __exports__